(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-video-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tab-button').forEach(button => {
button.addEventListener('click', () => {
const tabId = button.getAttribute('data-tab');

// Deactivate all buttons and tabs
document.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
document.querySelectorAll('.tab-content').forEach(content => {
content.classList.remove('active');
// Pause any videos inside inactive tabs
const video = content.querySelector('video');
if (video) {
video.pause();
video.currentTime = 0;
}
});

// Activate clicked button and tab
button.classList.add('active');
const targetTab = document.getElementById(tabId);
targetTab.classList.add('active');

// Play video if present in activated tab
const activeVideo = targetTab.querySelector('video');
if (activeVideo) {
activeVideo.play();
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-tabhing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tab-button').forEach(button => {
button.addEventListener('click', () => {
const tabId = button.getAttribute('data-tab');

// Deactivate all buttons and tabs
document.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
document.querySelectorAll('.tab-content').forEach(content => {
content.classList.remove('active');
// Pause any videos inside inactive tabs
const video = content.querySelector('video');
if (video) {
video.pause();
video.currentTime = 0;
}
});

// Activate clicked button and tab
button.classList.add('active');
const targetTab = document.getElementById(tabId);
targetTab.classList.add('active');

// Play video if present in activated tab
const activeVideo = targetTab.querySelector('video');
if (activeVideo) {
  activeVideo.muted = true; 
  const playPromise = activeVideo.play();
  if (playPromise !== undefined) {
    playPromise.catch(err => {
      console.warn('Autoplay prevented by browser policy', err);
    });
  }
}
});
});

  } catch(e) { console.error(e); }
})();
})();
